export const PAGES = {
  HOME: '/',

  CONNECT: '/connect',

  DASHBOARD: '/',

  SWAP: '/swap',

  EARN_STAKING: '/earn/staking',

  EARN_MINING: '/earn/mining',

  PERPETUAL: '/perpetual',

  REWARDS: '/rewards',

  LEVERAGE: '/leverage',

  STATS: '/stats',

  SETTINGS: '/settings',

  FAUCET: '/faucet',

  UNKNOWN: '/unknown',
} as const;
